var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 26.9682,
    rx: 13.5391,
    ry: 2.22795,
    fill: "url(#paint0_radial_1241_65032)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9998,
    cy: 26.9683,
    rx: 5.48418,
    ry: 0.342761,
    fill: "url(#paint1_radial_1241_65032)",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.63508L5.60653 4.83252L6.98721 10.2402L2.5 13.1166V6.63508Z",
    fill: "#FF8A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9279 0L16.766 1.61079L12.087 6.13636L7.71484 3.60511L13.9279 0Z",
    fill: "#019DF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5105 6.63485L17.9551 2.2627L18.1852 8.59082L25.5105 10.7769V6.63485Z",
    fill: "#BEAAF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4732 20.2499V11.0454L19.0684 15.1491L21.0243 22.8196L25.4732 20.2499Z",
    fill: "#FCD300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94531 16.7983L2.46094 15.2642V20.2883L8.13707 23.5482L7.94531 16.7983Z",
    fill: "#06BF97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8315 22.9345L13.9664 19.2144L9.0957 24.1618L13.9664 26.9999L20.8315 22.9345Z",
    fill: "#8EEA36"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1241_65032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 26.9682) rotate(90) scale(2.22795 13.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1241_65032",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9998 26.9682) rotate(90) scale(0.342761 5.48418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.53be73bae6a1aec92053ed772e68cc9c.svg";
export { ForwardRef as ReactComponent };